import { ProfileInfoFull } from "./components";
import { ProfileInfoShort } from "./components";

export const ProfileInfo = {
  ProfileInfoFull,
  ProfileInfoShort,
};
